import Vue from 'vue'
import VueRouter from 'vue-router'
import Head from '@/views/Head.vue'
import move from '@/views/move.vue'
import zhengshu from '@/views/zhengshu.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'head',
    component: Head
  },
  {
    path: '/move',
    name: 'move',
    component: move
  },
  {
    path: '/zhengshu',
    name: 'zhengshu',
    component: zhengshu
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
